module.exports = __webpack_public_path__ + "img/p4.aee7317e.png";